import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { EditerBox, InputChkSection } from "component/app/items";
import { appType, birthdaySet, isMobile, setDateTime, tokenSave } from "js/function";
import { CustomPopup } from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { ChkBox, CustomSelect, DatePicerRange, InputBoxCol2, InputItemBox } from "component/basic/formItems";
import timeData from "data/time.json";
import endTimeData from "data/endTime.json";
import { IconInfoText } from "component/app/subItem";
import { Map, MapMarker } from "react-kakao-maps-sdk";

const InsuranceItem = (data) => {
    return (
        <button type="button" className={`insuranceItem ${data.value === data.id ? "active" : ""}`} onClick={()=>{data.func(data.id)}}>
            <div className="insuranceItem_chk"/>
            <div className="insuranceItem_textBox">
                <h2 className="insuranceItem_name" dangerouslySetInnerHTML={{__html:data.name}}/>
                {data.infoText ? <p className="insuranceItem_infoText" dangerouslySetInnerHTML={{__html:data.infoText}}/> : ""}
            </div>
        </button>
    );
};

const DateSelectPopup = (data) => {
    const [startDate,setStartDate] =  useState(null);
    const [endDate,setEndDate] =  useState(null);
    const [startTime,setStartTime] =  useState("10:00");
    const [endTime,setEndTime] =  useState("10:00");
    const [dataSetChk, setDataSetChk] = useState(false);

    const [btnChk,setBtnChk] =  useState(true);

    useEffect(() => {
        if(startDate && endDate && startTime && endTime){
            setBtnChk(false)
        }else{
            setBtnChk(true)
        }
    }, [startDate,endDate,startTime,endTime]);

    return (
        <CustomPopup data={data.popupData}>
            <DatePicerRange
                inputName=""
                placeholder=""
                value={startDate && endDate ? `${startDate.replace(/-/g, "/")} - ${endDate.replace(/-/g, "/")}` : null}
                minCount={1}
                inline={true}
                dataChk={dataSetChk}
                func={(start, end) => {
                    if(start && end){
                        setStartDate(setDateTime(start,"yymmdd","hymd"));
                        setEndDate(setDateTime(end,"yymmdd","hymd"));
                    }
                }}
            />
            <InputBoxCol2>
                <CustomSelect
                    addClass="absoluteSelTop"
                    inputName="대여 시간"
                    placeholder="대여 시간 선택"
                    value={startTime}
                    func={(name,val) => {
                        setStartTime(val);
                    }}
                    disabled={false}
                    valKey="value"
                    nameKey="value"
                    options={timeData?.times}
                />
                <CustomSelect
                    addClass="absoluteSelTop"
                    inputName="반납 시간"
                    placeholder="반납 시간 선택"
                    value={endTime}
                    func={(name,val) => {
                        setEndTime(val);
                    }}
                    disabled={false}
                    valKey="value"
                    nameKey="value"
                    options={endTimeData?.times}
                />
            </InputBoxCol2>
            {data.btnType ? 
                <BtnBox
                    boxType="fixed"
                    addClass={`${data.subBtnText ? "col2": ""}`}
                >
                    {data.subBtnText ? 
                        <BtnItem
                            addClass="subColor"
                            contents={data.subBtnText}
                            func={() => {data.subBtnFunc()}}
                        />
                    :""}
                    <BtnItem
                        addClass=""
                        contents={data.btnText}
                        disabled={btnChk}
                        func={() => {data.btnFunc(`${startDate} ${startTime}`,`${endDate} ${endTime}`)}}
                    />
                </BtnBox>
            :""}
        </CustomPopup>
    );
};

const InsurancePopup = (data) => {
    const [insuranceId,setInsuranceId] =  useState(1);
    const [btnChk,setBtnChk] =  useState(true);

    useEffect(() => {
        if(insuranceId){
            setBtnChk(false)
        }else{
            setBtnChk(true)
        }
    }, [insuranceId]);

    return (
        <CustomPopup data={data.popupData}>
            <div className="insuranceItemBox">
                {data.data?.map((item,i)=>(
                    <InsuranceItem
                        id={item.id}
                        name={item.name}
                        infoText={item.infoText||null}
                        key={i}
                        value={insuranceId}
                        func={(id)=>{setInsuranceId(id)}}
                    />
                ))}
            </div>
            <IconInfoText
                name="<span class='wbTextColor'>자차보험</span>이란?"
                text="고객의 실수로 발생한 자차사고에 대해서 임차인과 렌터카 회사의 계약된 약정에 따라 임차임의 책임을 감면해 주는 차량손해면책제도(CDW)입니다."
            />
            {data.btnType ? 
                <BtnBox
                    boxType="fixed"
                    addClass={`${data.subBtnText ? "col2": ""}`}
                >
                    {data.subBtnText ? 
                        <BtnItem
                            addClass="subColor"
                            contents={data.subBtnText}
                            func={() => {data.subBtnFunc()}}
                        />
                    :""}
                    <BtnItem
                        addClass=""
                        contents={data.btnText}
                        disabled={btnChk}
                        func={() => {data.btnFunc(insuranceId)}}
                    />
                </BtnBox>
            :""}
        </CustomPopup>
    );
};

function MamberSubTitle(data){

    return (
        <h2 className="mamberSubTitle" dangerouslySetInnerHTML={{__html:data.title}}/>
    );
}

function SnsBtn(data){
    let navigate = useNavigate();

    return (
        <>
        {data.btnType == "link" ? 
        <a href={data.btnLink} target="_blank" id={data.id||""} className={`snsBtn ${data.addClass ? data.addClass : ""}`} onClick={() => data.func()} disabled={data.disabled ? data.disabled : false}>
            <img src={`/assets/images/sns/${data.img}.svg`}/>
        </a>
        :
        <button type="button" id={data.id||""} className={`snsBtn ${data.addClass ? data.addClass : ""}`} onClick={() => data.func()} disabled={data.disabled ? data.disabled : false}>
            <img src={`/assets/images/sns/${data.img}.svg`}/>
        </button>
        }
        </>
    );
}

function LoginLinkBtn(data){
    let navigate = useNavigate();

    return (
        <button type="button" id={data.id||""} className={`loginLinkBtn ${data.addClass ? data.addClass : ""}`} onClick={() => data.func()} disabled={data.disabled ? data.disabled : false} dangerouslySetInnerHTML={{__html:data.text}}/>
    );
}

const TermsPopup = (data) => {
    const termsDetailApi = useGet({
        url: data.popupData?.terms?.id && data.popupData?.terms?.id !== "payment" ? `/term/detail?type=${data.popupData?.terms?.id}` : null,
    });
    const termsDetailData = termsDetailApi?.data?.term;

    const paymentTermsApi = useGet({
        url: data.popupData?.terms?.id === "payment" ? `/info/payment` : null,
    });
    const paymentTermsData = paymentTermsApi?.data?.payment_information;

    useEffect(() => {
        
    }, []);

    return (
        <CustomPopup data={data.popupData} basicPB={true} mSize={true}>
            <EditerBox addClass="" data={data.popupData?.terms?.id === "payment" ? paymentTermsData : termsDetailData?.contents}/>
            {data?.popupData?.btnText ? 
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass=""
                        contents={data?.popupData?.btnText}
                        disabled={false}
                        func={() => {data.btnFunc(data.popupData?.terms)}}
                    />
                </BtnBox>
            :""}
        </CustomPopup>
    );
};

const WelComePopup = (data) => {

    //애플
    function appleLoginStart(){
        window.location.href = `https://appleid.apple.com/auth/authorize?client_id=${process.env.REACT_APP_APPLE_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_APPLE_REDIRECT_URL}`;
    }

    //구글
    function googleLoginStart(){
        if(appType() === "Android"){
            window.arentacarhub.googleLoginCheck()
        }else if(appType() === "iOS"){
            window.webkit.messageHandlers.googleLoginCheckHandler.postMessage("login");
        }else{
            window.location.href = `https://accounts.google.com/o/oauth2/auth?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_GOOGLE_REDIRECT_URL}&response_type=code&scope=openid email profile`;
        }
    }

    //네이버
    function naverLoginStart() {
        if(appType() === "Android"){
            window.arentacarhub.naverLoginCheck()
        }else if(appType() === "iOS"){
            window.webkit.messageHandlers.naverLoginCheckHandler.postMessage("login");
        }else{
            window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${process.env.REACT_APP_NAVER_CLIENT_ID}&state=false&redirect_uri=${process.env.REACT_APP_NAVER_REDIRECT_URL}`;
        }
    }

    //카카오
    function kakaoLoginStart() {
        if(appType() === "Android"){
            window.arentacarhub.kakaoLoginCheck()
        }else if(appType() === "iOS"){
            window.webkit.messageHandlers.kakaoLoginCheckHandler.postMessage("login");
        }else{
            window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${process.env.REACT_APP_KAKAO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_KAKAO_REDIRECT_URL}&response_type=code`;
        }
    }

    useEffect(() => {
        
    }, []);

    return (
        <CustomPopup data={data.popupData} toastType={true} basicPB={true}>
            <BtnItem
                addClass=""
                contents="A 렌터카 허브 로그인"
                disabled={false}
                func={() => {window.loginPopupOpen();window.welComeClose()}}
            />
            {data?.popupData?.nonMember ? 
                <BtnItem
                    addClass="line colBtn"
                    contents="비회원 예약 확인"
                    disabled={false}
                    func={() => {window.nonMemberPopupOpen();window.welComeClose()}}
                />
            :""}
            <div className={"welcome_sns_area"}>
                <div className="welcome_sns">
                    <p className="welcome_sns_text" style={{marginLeft: "30%"}}>다른 방법으로 로그인</p>
                </div>
                <p
                    className="welcome_join_text"
                    onClick={() => {
                        window.welComeClose();
                        window.joinPopupOpen("normal");
                    }}
                >회원가입</p>
            </div>
            <div className="welcome_snsBtnBox">
            <SnsBtn
                    img="naver"
                    func={() => {naverLoginStart();window.welComeClose()}}
                />
                <SnsBtn
                    img="kakao"
                    func={() => {kakaoLoginStart();window.welComeClose()}}
                />
                <SnsBtn
                    img="google"
                    func={() => {googleLoginStart();window.welComeClose()}}
                />
                <SnsBtn
                    img="apple"
                    func={() => {appleLoginStart();window.welComeClose()}}
                />
            </div>
            {data?.popupData?.filterData && (
                <>
                    <div className={"welcome_reservation_text"}>
                        비회원 예약을 원하시면 X[닫기]를 눌러주세요

                    </div>
                </>
            )}
        </CustomPopup>
    );
};

const NomMemberPopup = (data) => {
    const navigate = useNavigate();
    const [page,setPage] =  useState(0);

    const [number,setNumber] =  useState(null);
    const [phone,setPhone] =  useState(null);

    const [cetified,setCetified] =  useState("");
    const [certifyErr,setCertifyErr] =  useState(null);
    const [timerCount,setTimerCount] =  useState("3:00");
    const [cetifiedChk,setCetifiedChk] =  useState(false);
    const [cetifiedComChk,setCetifiedComChk] =  useState(false);
    
    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);

    function reSet(){
        setPage(0);

        setNumber(null);
        setPhone(null);

        setCetified("");
        setCertifyErr(null);
        setTimerCount("3:00");
        setCetifiedChk(false);
        setCetifiedComChk(false);

        setBtnChk(true);
        setSubmitChk(true);
    }

    function nextSetting(){
        if(page + 1 <= 1){   
            setBtnChk(true);
            setPage(page + 1);
        }
    }

    const sval = useRef(null);
    function timerStart(){
        //타이머
        setTimerCount("3:00");
        setCertifyErr("");
        
        if (sval.current !== null) {
            clearInterval(sval.current);
            sval.current = null;
        }
        
        timerChk(2.99);

        function timerChk(duration) {
            let timerNumber = duration * 60;
            let m, s;
            sval.current = setInterval(function() {
                m = parseInt(timerNumber / 60 % 60, 10);
                s = parseInt(timerNumber % 60, 10);
                s = s < 10 ? "0" + s : s;

                setTimerCount(m + ":" + s);

                if (--timerNumber < 0) {
                    timerNumber = 0;
                    clearInterval(sval.current);
                    sval.current = null;
                    setCertifyErr("인증시간이 초과되었습니다.");
                    setCetifiedComChk(true);
                    setCetified("");

                    setBtnChk(false);
                }
            }, 1000);
        }
    }

    function cetifiedStert(){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("phone", phone?.replace(/\-/g,""));

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: null,
                url: `/sms/certification`,
                success: (apiData) => {
                    setSubmitChk(true);

                    timerStart();
                    setCetified("");
                    setCetifiedChk(true);
                    window.loadingBox(false);

                    setBtnChk(true);

                    window.nonMemberPopupTextCh({
                        title:"인증번호 입력",
                        subTitle:"SMS로 발송된 인증번호를 입력하세요."
                    });

                    if(page !== 1){
                        nextSetting();
                    }
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    function reservationChk(){
        let formData = new FormData();
        formData.append("reservation_code", number);
        formData.append("phone", phone?.replace(/\-/g,""));
        formData.append("code", cetified);

        fatchSet.FatchApi({
            type:"POST",
            formDataItem: formData,
            url: "/reservation/sms/certification/check",
            success: (apiData) => {
                setSubmitChk(true);

                setBtnChk(false);
                setCetifiedComChk(true);

                setTimerCount("3:00");
                setCertifyErr("");

                clearInterval(sval.current);
                sval.current = null;

                window.loadingBox(false);
                
                window.nonMemberPopupClose();
                reSet();

                navigate(`/reservation/detail/${apiData.data.reservation_id}`,{state: {memberCode:{code:cetified,phone:phone?.replace(/\-/g,"")}}});
            },
            err: (apiData) => {
                setSubmitChk(true);
                if(apiData?.data || apiData?.alert){
                    window.errPopupOpen(apiData);
                }
                window.loadingBox(false);
            }
        })
    }

    useEffect(() => {
        let phoneChk = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
        if(page == 0){
            if(number && number?.length >= 14
            && phoneChk.test(phone?.replace(/\-/g,""))){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [number,phone]);

    useEffect(() => {
        if(page == 1){
            if(cetified.length == 6){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [cetified,cetifiedChk]);

    useEffect(() => {
        if(data.popupData === null){
            reSet();
        }
    }, [data.popupData]);

    return (
        <CustomPopup data={data.popupData}>
            {page === 0 ? 
            <>
            <InputItemBox
                inputType={null}
                addClass=""
                inputName="예약번호"
                placeholder="문자/메일을 통해 전달받은 예약번호 입력"
                value={number}
                max={null}
                reservationNumberSetting={true}
                regexp={/[^0-9\-]/gi}
                inputMode="numeric"
                pattern="[0-9]*"
                func={(value)=>{setNumber(value)}}
            />
            <InputItemBox
                inputType={null}
                addClass=""
                inputName="예약자 휴대폰 번호"
                placeholder="‘-’ 없이 입력"
                value={phone}
                max={13}
                phoneSetting={true}
                regexp={"number"}
                inputMode="numeric"
                pattern="[0-9]*"
                func={(value)=>{setPhone(value)}}
            />
            </>
            : page === 1 && cetifiedChk ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass="cetifiedInput"
                    inputName="인증번호"
                    placeholder="인증번호 6자리"
                    value={cetified}
                    max={6}
                    readOnly={cetifiedComChk}
                    cetified={timerCount}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setCetified(value)}}
                    errMsg={certifyErr}
                    subBtn="인증번호 재발송"
                    inputSubFunc={()=>{cetifiedStert();setCetifiedComChk(false);setCetified("")}}
                />
                </>
            :""}
            
            <BtnBox
                boxType="fixed"
                addClass="col2"
            >
                <BtnItem
                    addClass="subColor"
                    contents={"닫기"}
                    func={() => {
                        window.nonMemberPopupClose();
                        reSet();
                    }}
                />
                <BtnItem
                    addClass=""
                    contents={page === 0 ? "다음" : "예약내역 조회"}
                    disabled={btnChk}
                    func={() => {if(page === 0){cetifiedStert()}else if(page === 1){reservationChk()}}}
                />
            </BtnBox>
        </CustomPopup>
    );
};

const LoginPopup = (data) => {
    const navigate = useNavigate();

    const [id,setId] =  useState(null);
    const [pw,setPw] =  useState(null);
    const [btnChk,setBtnChk] =  useState(true);

    function reSet(){
        setId(null);
        setPw(null);
        setBtnChk(true);
    }

    function loginStart(){
        let formData = new FormData();
        formData.append("login_id", id);
        formData.append("password", pw);

        fatchSet.FatchApi({
            type:"POST",
            formDataItem: formData,
            url: "/login",
            success: (apiData) => {
                data.popupData?.closeFunc();

                localStorage.setItem("token",apiData?.data?.token?.access_token);
                localStorage.setItem("refresh_token",apiData?.data?.token?.refresh_token);

                tokenSave(apiData?.data?.token?.access_token);

                window.logIn();

                setTimeout(() => {                    
                    window.location.reload(true);
                }, 100);
            },
            err: (apiData) => {
                window.errPopupOpen(apiData);
            }
        })
    }

    useEffect(() => {
        if(id && id?.length >= 5 && pw){
            setBtnChk(false)
        }else{
            setBtnChk(true)
        }
    }, [id,pw]);

    useEffect(() => {
        if(data.popupData === null){
            reSet();
        }
    }, [data.popupData]);

    return (
        <CustomPopup data={data.popupData}>
            <InputItemBox
                inputType={null}
                addClass=""
                inputName="아이디"
                placeholder="아이디를 입력하세요"
                value={id}
                max={15}
                regexp={/[^a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi}
                func={(value)=>{setId(value)}}
                idInputMsgChk={true}
            />
            <InputItemBox
                inputType="password"
                addClass=""
                inputName="비밀번호"
                placeholder="비밀번호를 입력하세요"
                pwChType={false}
                value={pw}
                max={16}
                regexp={null}
                func={(value)=>{setPw(value)}}
            />
            <div className="loginLinkBtn_box">
                <div className="loginLinkBtn_subBox">
                    <LoginLinkBtn
                        func={() => {
                            window.loginPopupClose();
                            window.idFindPopupOpen();
                        }}
                        text={"아이디 찾기"}
                    />
                    <LoginLinkBtn
                        func={() => {
                            window.loginPopupClose();
                            window.pwFindPopupOpen();
                        }}
                        text={"비밀번호 찾기"}
                    />
                </div>
                <LoginLinkBtn
                    func={() => {
                        window.loginPopupClose();
                        window.joinPopupOpen("normal");
                    }}
                    text={"일반 회원가입"}
                />
            </div>
            <BtnBox
                boxType="fixed"
                addClass="col2"
            >
                <BtnItem
                    addClass="subColor"
                    contents={"뒤로"}
                    func={() => {
                        window.loginPopupClose();
                        reSet();
                        window.welComeOpen();
                    }}
                />
                <BtnItem
                    addClass=""
                    contents={"로그인"}
                    disabled={btnChk}
                    func={() => {loginStart()}}
                />
            </BtnBox>
        </CustomPopup>
    );
};

const JoinPopup = (data) => {
    const navigate = useNavigate();

    const [page,setPage] =  useState(data?.popupData?.joinType === "sns" ? 1 : 0);

    const [id,setId] =  useState("");
    const [pw,setPw] =  useState("");
    const [pwCom,setPwCom] =  useState("");

    const [idErr,setIdErr] =  useState(null);
    const [pwErr,setPwErr] =  useState(null);
    const [pwComErr,setPwComErr] =  useState(null);

    const [idChk,setIdChk] =  useState(false);

    const [cetified,setCetified] =  useState("");
    const [certifyErr,setCertifyErr] =  useState(null);
    const [timerCount,setTimerCount] =  useState("3:00");
    const [cetifiedChk,setCetifiedChk] =  useState(false);
    const [cetifiedComChk,setCetifiedComChk] =  useState(false);

    const [responseSeq,setResponseSeq] =  useState("");

    const [name,setName] =  useState("");
    const [birthday,setBirthday] =  useState("");
    const [phone,setPhone] =  useState("");
    const [phoneType,setPhoneType] =  useState("");
    const [gender,setGender] =  useState("m");

    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);

    const termsData = [
        {
            id:"service",
            title:"서비스 이용 약관"
        },
        {
            id:"privacy",
            title:"개인정보 수집 및 이용 동의"
        }
    ];

    const [checkItems, setCheckItems] = useState([]);
    const [checkItemTitles, setCheckItemTitles] = useState([]);
    const [marketing,setMarketing] =  useState(false);

    function reSet(){
        setId("");
        setPw("");
        setPwCom("");

        setIdErr(null);
        setPwErr(null);
        setPwComErr(null);

        setIdChk(false);

        setCetified("");
        setCertifyErr(null);
        setTimerCount("3:00");
        setCetifiedChk(false);
        setCetifiedComChk(false);

        setResponseSeq("");

        setName("");
        setBirthday("");
        setPhone("");
        setPhoneType("");
        setGender("m");

        setBtnChk(true);
        setSubmitChk(true);

        setCheckItems([]);
        setCheckItemTitles([]);
        setMarketing(false);
    }

    const sval = useRef(null);
    function timerStart(){
        //타이머
        setTimerCount("3:00");
        setCertifyErr("");
        
        if (sval.current !== null) {
            clearInterval(sval.current);
            sval.current = null;
        }
        
        timerChk(2.99);

        function timerChk(duration) {
            let timerNumber = duration * 60;
            let m, s;
            sval.current = setInterval(function() {
                m = parseInt(timerNumber / 60 % 60, 10);
                s = parseInt(timerNumber % 60, 10);
                s = s < 10 ? "0" + s : s;

                setTimerCount(m + ":" + s);

                if (--timerNumber < 0) {
                    timerNumber = 0;
                    clearInterval(sval.current);
                    sval.current = null;
                    setCertifyErr("인증시간이 초과되었습니다.");
                    setCetifiedComChk(true);
                    setCetified("");

                    setBtnChk(false);
                }
            }, 1000);
        }
    }

    function cetifiedStert(){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("name", name);
            formData.append("birth", birthdaySet(birthday,gender));
            formData.append("phone", phone?.replace(/\-/g,""));
            formData.append("mobile_carrier", phoneType.val);
            formData.append("is_join", 1);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: data?.popupData?.joinType === "sns" ? "sessionLogin" : null,
                url: `/certification`,
                success: (apiData) => {
                    setSubmitChk(true);

                    timerStart();
                    setCetified("");
                    setCetifiedChk(true);
                    window.loadingBox(false);

                    setBtnChk(true);

                    setResponseSeq(apiData?.data?.response_seq);

                    window.joinPopupTextCh({
                        title:"인증번호 입력",
                        subTitle:"SMS로 발송된 인증번호를 입력하세요."
                    });

                    if(page !== 2){
                        joinNextFunc();
                    }
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    function idChkFunc(){
        let idType = /(^(?=.*[a-z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]).{5,15}$)/;

        if(submitChk && idType.test(id)){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("login_id", id);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: null,
                url: `/id/overlap`,
                success: (apiData) => {
                    setSubmitChk(true);
                    window.loadingBox(false);

                    setIdErr(null)
                    setIdChk(true);
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    setIdChk(false);
                    setIdErr("이미 가입된 아이디 입니다.")
                    window.loadingBox(false);
                }
            })
        }
    }

    // 체크박스 선택
    const handleSingleCheck = (checked, id, text) => {
        if (checked) {
            setCheckItemTitles(prev => [...prev, text]);
            setCheckItems(prev => [...prev, id]);
        } else {
            setCheckItemTitles(checkItemTitles.filter((el) => el !== text));
            setCheckItems(checkItems.filter((el) => el !== id));
        }
    };

    // 체크박스 전체 선택
    const handleAllCheck = (checked) => {
        if(checked) {
        const idArr = [],
            textArr = [];
            termsData?.forEach((el) => {idArr.push(el.id);textArr.push(el.term_title)});
            setCheckItemTitles(textArr);
            setCheckItems(idArr);
            setMarketing(true);
        }
        else {
            setCheckItemTitles([]);
            setCheckItems([]);
            setMarketing(false);
        }
    }

    function joinNextFunc(){
        setBtnChk(true);
        setIdErr(null);
        setPwErr(null);
        setPwComErr(null);
                    
        setPage(page + 1);
    }

    function joinNext(){
        if(page == 0){
            joinNextFunc();
            window.joinPopupTextCh({
                title:"본인인증 정보 입력",
                subTitle:"회원가입을 위해 본인인증이 필요해요"
            });
        }else if(page == 1){
            cetifiedStert();
        }else if(page == 2){
            if(submitChk){
                if(cetifiedChk){
                    setSubmitChk(false);
                    window.loadingBox(true);

                    let formData = new FormData();

                    if(data?.popupData?.joinType !== "sns"){
                        formData.append("login_id", id);
                        formData.append("password", pw);
                    }

                    formData.append("name", name);
                    formData.append("birth", birthdaySet(birthday,gender));
                    formData.append("phone", phone?.replace(/\-/g,""));
                    formData.append("mobile_carrier", phoneType.val);

                    formData.append("response_seq", responseSeq);
                    formData.append("certification_code", cetified);

                    formData.append("is_agree_event_alarm", marketing);
                    formData.append("is_join", 1);
                    formData.append("join_method", isMobile() ? "mobile" : "pc");

                    fatchSet.FatchApi({
                        type:"POST",
                        formDataItem: formData,
                        loginType: data?.popupData?.joinType === "sns" ? "sessionLogin" : null,
                        url: `/certification/check`,
                        success: (apiData) => {
                            setSubmitChk(true);

                            setBtnChk(false);
                            setCetifiedComChk(true);

                            setTimerCount("3:00");
                            setCertifyErr("");

                            clearInterval(sval.current);
                            sval.current = null;

                            window.loadingBox(false);
                            
                            if(data?.popupData?.joinType == "normal"){
                                localStorage.setItem("token",apiData?.data?.token?.access_token);
                                localStorage.setItem("refresh_token",apiData?.data?.token?.refresh_token);

                                tokenSave(apiData?.data?.token?.access_token);
                            }else{
                                localStorage.setItem("token", sessionStorage.getItem("token"));
                                localStorage.setItem("refresh_token", sessionStorage.getItem("refresh_token"));

                                tokenSave(sessionStorage.getItem("token"));
                            }

                            window.errPopupOpen({
                                alert:"회원가입 완료",
                                data:"서비스 회원가입이 완료되었습니다.<br/>지금 바로 서비스를 이용해보세요!",
                                closeType:false,
                                func:()=>{
                                    window.logIn();
                                    window.location.reload(true);
                                }
                            });

                            setTimeout(() => {     
                                window.logIn();               
                                window.location.reload(true);
                            }, 5000);
                        },
                        err: (apiData) => {
                            setSubmitChk(true);
                            if(apiData.alert){
                                setCertifyErr(apiData.alert);
                            }
                            window.loadingBox(false);
                        }
                    })
                }else{
                    cetifiedStert();setCetifiedComChk(false);setCetified("")
                }
            }
        }
    }

    useEffect(() => {
        let idType = /(^(?=.*[a-z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]).{5,15}$)/;
        let pwType = /^(?=.*[a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]).{8,16}$/;

        if(!idType.test(id) && id !== ""){
            setIdErr("5자 ~ 15자 영문 소문자, 숫자로 입력하세요.")
        }else{
            setIdErr(null)
        }

        if(pw !== pwCom && pw !== "" && pwCom !== ""){
            setPwComErr("비밀번호가 일치하지 않습니다.")
        }else{
            setPwComErr(null)
        }

        if(!pwType.test(pw) && pw !== ""){
            setPwErr("8자 ~ 16자 영문, 숫자, 특수문자로 입력하세요.")
        }else{
            setPwErr(null)
        }

        if(page == 0){
            if(
                idType.test(id) && id !== ""
                && pwType.test(pw) && pw !== ""
                && pw == pwCom && pwType.test(pw)
                && idChk
            ){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [id,pw,pwCom,idChk]);

    useEffect(() => {
        let ragChk = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/g;
        let phoneChk = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
        let chkSet = [...checkItems];
        if(page == 1){
            if(name.length > 0 
            && ragChk.test(birthday)
            && gender
            && phoneChk.test(phone?.replace(/\-/g,""))
            && phoneType.val
            && chkSet.length == (termsData ? termsData?.length : 0)){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [name,birthday,gender,phone,phoneType,checkItems]);

    useEffect(() => {
        if(page == 2){
            if(cetified.length == 6){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [cetified,cetifiedChk]);

    useEffect(() => {
        if(data.popupData === null){
            reSet();
        }
        if(data?.popupData?.joinType === "sns" && data.popupData?.title === "본인인증 정보 입력"){
            setPage(1);
        }
    }, [data.popupData]);

    return (
        <CustomPopup data={data.popupData}>
            {page === 0 ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="아이디"
                    placeholder="5자 ~ 15자의 영문 소문자, 숫자 입력"
                    value={id}
                    blurInput={()=>{idChkFunc()}}
                    max={15}
                    regexp={/[^a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi}
                    func={(value)=>{setId(value)}}
                    errMsg={idErr}
                    idInputMsgChk={true}
                />
                <InputItemBox
                    inputType="password"
                    addClass=""
                    inputName="비밀번호"
                    placeholder="8~16자 영문, 숫자, 특수문자 (대소문자 구분)"
                    pwChType={false}
                    value={pw}
                    max={16}
                    regexp={null}
                    errMsg={pwErr}
                    func={(value)=>{setPw(value)}}
                />
                <InputItemBox
                    inputType="password"
                    addClass=""
                    inputName="비밀번호 확인"
                    placeholder="8~16자 영문, 숫자, 특수문자 (대소문자 구분)"
                    pwChType={false}
                    value={pwCom}
                    max={16}
                    regexp={null}
                    errMsg={pwComErr}
                    func={(value)=>{setPwCom(value)}}
                />
                </>
            : page === 1 ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="휴대폰 번호"
                    placeholder="‘-’ 없이 입력"
                    value={phone}
                    max={13}
                    phoneSetting={true}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setPhone(value);setCetifiedChk(false);setCetifiedComChk(false);setCetified("")}}
                />
                <CustomSelect
                    addClass="notName absoluteSel"
                    inputName="통신사"
                    placeholder="선택"
                    value={phoneType?.val}
                    func={(name,val) => {
                        let dataSet = {
                            val:val,
                            text:name
                        }
                        setPhoneType(dataSet);
                    }}
                    disabled={false}
                    valKey="id"
                    nameKey="name"
                    options={[
                        {id:1,name:"SKT"},
                        {id:2,name:"KT"},
                        {id:3,name:"LGU+"},
                        {id:5,name:"알뜰폰(SKT)"},
                        {id:6,name:"알뜰폰(KT)"},
                        {id:7,name:"알뜰폰(LGU+)"}
                    ]}
                />
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="이름"
                    placeholder="이름"
                    value={name}
                    max={18}
                    regexp={null}
                    func={(value)=>{setName(value)}}
                />
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="생년월일"
                    placeholder="YYYYMMDD"
                    value={birthday}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    max={8}
                    func={(value)=>{setBirthday(value)}}

                    inBtnArr={[
                        {
                            val: "m", 
                            text: "남", 
                            func: (val)=>{setGender(val)}
                        },
                        {
                            val: "f", 
                            text: "여", 
                            func: (val)=>{setGender(val)}
                        }
                    ]}
                    inBtnValue={gender}
                />
                <InputChkSection>
                    <ChkBox
                        addClass="allChkItem"
                        func={(e) => handleAllCheck(e.target.checked)}
                        checkedType={checkItems?.length === (termsData ? termsData?.length : 0) && marketing ? true : false}
                        label="전체 약관에 동의합니다."
                    />
                    {termsData?.map((item, i) => (
                        <ChkBox
                            key={i}
                            addClass=""
                            func={(e) => handleSingleCheck(e.target.checked,item.id,item.title)}
                            checkedType={checkItems.includes(item.id) ? true : false}
                            label={`<span>[필수]</span> ${item.title}`}
                            chkFunc={(e) => window.termsPopupOpen(item.id,item.title)}
                        />
                    ))}
                    <ChkBox
                        addClass=""
                        func={(e) => setMarketing(e.target.checked)}
                        checkedType={marketing}
                        label={`<span>[선택]</span> 이벤트 및 혜택 정보 수신 동의`}
                        chkFunc={()=>{window.termsPopupOpen("event","이벤트 및 혜택 정보 수신 동의")}}
                    />
                </InputChkSection>
                </>
            : page === 2 && cetifiedChk ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass="cetifiedInput"
                    inputName="인증번호"
                    placeholder="인증번호 6자리"
                    value={cetified}
                    max={6}
                    readOnly={cetifiedComChk}
                    cetified={timerCount}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setCetified(value)}}
                    errMsg={certifyErr}
                    subBtn="인증번호 재발송"
                    inputSubFunc={()=>{cetifiedStert();setCetifiedComChk(false);setCetified("")}}
                />
                </>
            :""}
            <BtnBox
                boxType="fixed"
                addClass="col2"
            >
                <BtnItem
                    addClass="subColor"
                    contents={page === 0 ? "뒤로" : "닫기"}
                    func={() => {
                        window.joinPopupClose();
                        if(page === 0){
                            reSet();
                            setPage(0);
                            window.loginPopupOpen();
                        }
                    }}
                />
                <BtnItem
                    addClass=""
                    contents={page === 0 ? "다음" : page === 1 ? "인증번호 발송" : "회원가입 완료"}
                    disabled={btnChk}
                    func={() => {joinNext()}}
                />
            </BtnBox>
        </CustomPopup>
    );
};

const IdFindPopup = (data) => {
    const navigate = useNavigate();

    const [page,setPage] =  useState(0);

    const [cetified,setCetified] =  useState("");
    const [certifyErr,setCertifyErr] =  useState(null);
    const [timerCount,setTimerCount] =  useState("3:00");
    const [cetifiedChk,setCetifiedChk] =  useState(false);
    const [cetifiedComChk,setCetifiedComChk] =  useState(false);

    const [responseSeq,setResponseSeq] =  useState("");

    const [name,setName] =  useState("");
    const [birthday,setBirthday] =  useState("");
    const [phone,setPhone] =  useState("");
    const [phoneType,setPhoneType] =  useState("");
    const [gender,setGender] =  useState("m");

    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);

    const termsData = [
        {
            id:"service",
            title:"서비스 이용 약관"
        },
        {
            id:"privacy",
            title:"개인정보 수집 및 이용 동의"
        }
    ];

    const [checkItems, setCheckItems] = useState([]);
    const [checkItemTitles, setCheckItemTitles] = useState([]);

    const [id,setId] =  useState("qweqwe");

    function reSet(){
        setPage(0);

        setId("");

        setCetified("");
        setCertifyErr(null);
        setTimerCount("3:00");
        setCetifiedChk(false);
        setCetifiedComChk(false);

        setResponseSeq("");

        setName("");
        setBirthday("");
        setPhone("");
        setPhoneType("");
        setGender("m");

        setBtnChk(true);
        setSubmitChk(true);

        setCheckItems([]);
        setCheckItemTitles([]);
    }

    const sval = useRef(null);
    function timerStart(){
        //타이머
        setTimerCount("3:00");
        setCertifyErr("");
        
        if (sval.current !== null) {
            clearInterval(sval.current);
            sval.current = null;
        }
        
        timerChk(2.99);

        function timerChk(duration) {
            let timerNumber = duration * 60;
            let m, s;
            sval.current = setInterval(function() {
                m = parseInt(timerNumber / 60 % 60, 10);
                s = parseInt(timerNumber % 60, 10);
                s = s < 10 ? "0" + s : s;

                setTimerCount(m + ":" + s);

                if (--timerNumber < 0) {
                    timerNumber = 0;
                    clearInterval(sval.current);
                    sval.current = null;
                    setCertifyErr("인증시간이 초과되었습니다.");
                    setCetifiedComChk(true);
                    setCetified("");

                    setBtnChk(false);
                }
            }, 1000);
        }
    }

    function cetifiedStert(){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("name", name);
            formData.append("birth", birthdaySet(birthday,gender));
            formData.append("phone", phone?.replace(/\-/g,""));
            formData.append("mobile_carrier", phoneType.val);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: null,
                url: `/certification`,
                success: (apiData) => {
                    setSubmitChk(true);

                    timerStart();
                    setCetified("");
                    setCetifiedChk(true);
                    window.loadingBox(false);

                    setBtnChk(true);

                    setResponseSeq(apiData?.data?.response_seq);

                    window.idFindPopupTextCh({
                        title:"인증번호 입력",
                        subTitle:"SMS로 발송된 인증번호를 입력하세요."
                    });

                    if(page !== 1){
                        nextSetting();
                    }
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    // 체크박스 선택
    const handleSingleCheck = (checked, id, text) => {
        if (checked) {
            setCheckItemTitles(prev => [...prev, text]);
            setCheckItems(prev => [...prev, id]);
        } else {
            setCheckItemTitles(checkItemTitles.filter((el) => el !== text));
            setCheckItems(checkItems.filter((el) => el !== id));
        }
    };

    // 체크박스 전체 선택
    const handleAllCheck = (checked) => {
        if(checked) {
        const idArr = [],
            textArr = [];
            termsData?.forEach((el) => {idArr.push(el.id);textArr.push(el.term_title)});
            setCheckItemTitles(textArr);
            setCheckItems(idArr);
        }
        else {
            setCheckItemTitles([]);
            setCheckItems([]);
        }
    }

    function nextSetting(){
        setBtnChk(page + 1 === 2 ? false : true);
                    
        setPage(page + 1);
    }

    function nextFunc(){
        if(page == 0){
            cetifiedStert();
        }else if(page == 1){
            if(submitChk){
                if(cetifiedChk){
                    setSubmitChk(false);
                    window.loadingBox(true);

                    let formData = new FormData();
                    
                    formData.append("name", name);
                    formData.append("birth", birthdaySet(birthday,gender));
                    formData.append("phone", phone?.replace(/\-/g,""));
                    formData.append("mobile_carrier", phoneType.val);

                    formData.append("response_seq", responseSeq);
                    formData.append("certification_code", cetified);
                    formData.append("find_id", 1);

                    fatchSet.FatchApi({
                        type:"POST",
                        formDataItem: formData,
                        loginType: null,
                        url: `/certification/check`,
                        success: (apiData) => {
                            setSubmitChk(true);

                            setBtnChk(false);
                            setCetifiedComChk(true);

                            setTimerCount("3:00");
                            setCertifyErr("");

                            clearInterval(sval.current);
                            sval.current = null;

                            window.loadingBox(false);

                            window.idFindPopupTextCh({
                                title:"아이디 찾기 결과",
                                subTitle:apiData?.data?.login_id ? "가입하신 계정정보 입니다.<br/>비밀번호를 잊으셨다면 비밀번호 찾기를 이용해주세요." : "가입하신 계정정보가 없습니다.<br/>원활한 서비스 이용을 위해 회원가입을 진행해주세요.",
                                addClass:apiData?.data?.login_id ? "subTitle_line_2" : "subTitle_line_1"
                            });

                            setId(apiData?.data?.login_id);
        
                            nextSetting();
                        },
                        err: (apiData) => {
                            setSubmitChk(true);
                            if(apiData?.data || apiData?.alert){
                                window.errPopupOpen(apiData);
                            }
                            window.loadingBox(false);
                        }
                    })
                }else{
                    cetifiedStert();setCetifiedComChk(false);setCetified("")
                }
            }
        }else if(page == 2){
            if(id && id !== ""){
                window.idFindPopupClose();
                reSet();
                window.loginPopupOpen();
            }else{
                window.idFindPopupClose();
                reSet();
                window.joinPopupOpen("normal");
            }
        }
    }

    useEffect(() => {
        let ragChk = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/g;
        let phoneChk = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
        let chkSet = [...checkItems];
        if(page == 0){
            if(name.length > 0 
            && ragChk.test(birthday)
            && gender
            && phoneChk.test(phone?.replace(/\-/g,""))
            && phoneType.val
            && chkSet.length == (termsData ? termsData?.length : 0)){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [name,birthday,gender,phone,phoneType,checkItems]);

    useEffect(() => {
        if(page == 1){
            if(cetified.length == 6){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [cetified,cetifiedChk]);

    useEffect(() => {
        if(data.popupData === null){
            reSet();
        }
    }, [data.popupData]);
    
    return (
        <CustomPopup data={data.popupData} toastType={page === 2 ? true : null}>
            {page === 0 ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="휴대폰 번호"
                    placeholder="‘-’ 없이 입력"
                    value={phone}
                    max={13}
                    phoneSetting={true}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setPhone(value);setCetifiedChk(false);setCetifiedComChk(false);setCetified("")}}
                />
                <CustomSelect
                    addClass="notName absoluteSel"
                    inputName="통신사"
                    placeholder="선택"
                    value={phoneType?.val}
                    func={(name,val) => {
                        let dataSet = {
                            val:val,
                            text:name
                        }
                        setPhoneType(dataSet);
                    }}
                    disabled={false}
                    valKey="id"
                    nameKey="name"
                    options={[
                        {id:1,name:"SKT"},
                        {id:2,name:"KT"},
                        {id:3,name:"LGU+"},
                        {id:5,name:"알뜰폰(SKT)"},
                        {id:6,name:"알뜰폰(KT)"},
                        {id:7,name:"알뜰폰(LGU+)"}
                    ]}
                />
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="이름"
                    placeholder="이름"
                    value={name}
                    max={18}
                    regexp={null}
                    func={(value)=>{setName(value)}}
                />
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="생년월일"
                    placeholder="YYYYMMDD"
                    value={birthday}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    max={8}
                    func={(value)=>{setBirthday(value)}}

                    inBtnArr={[
                        {
                            val: "m", 
                            text: "남", 
                            func: (val)=>{setGender(val)}
                        },
                        {
                            val: "f", 
                            text: "여", 
                            func: (val)=>{setGender(val)}
                        }
                    ]}
                    inBtnValue={gender}
                />
                <InputChkSection>
                    <ChkBox
                        addClass="allChkItem"
                        func={(e) => handleAllCheck(e.target.checked)}
                        checkedType={checkItems?.length === (termsData ? termsData?.length : 0) ? true : false}
                        label="전체 약관에 동의합니다."
                    />
                    {termsData?.map((item, i) => (
                        <ChkBox
                            key={i}
                            addClass=""
                            func={(e) => handleSingleCheck(e.target.checked,item.id,item.title)}
                            checkedType={checkItems.includes(item.id) ? true : false}
                            label={`<span>[필수]</span> ${item.title}`}
                            chkFunc={(e) => window.termsPopupOpen(item.id,item.title)}
                        />
                    ))}
                </InputChkSection>
                </>
            : page === 1 && cetifiedChk ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass="cetifiedInput"
                    inputName="인증번호"
                    placeholder="인증번호 6자리"
                    value={cetified}
                    max={6}
                    readOnly={cetifiedComChk}
                    cetified={timerCount}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setCetified(value)}}
                    errMsg={certifyErr}
                    subBtn="인증번호 재발송"
                    inputSubFunc={()=>{cetifiedStert();setCetifiedComChk(false);setCetified("")}}
                />
                </>
            : page === 2 && id && id !== "" ? 
                <div className="idFindBox">
                    <p className="idFindTitle">아이디</p>
                    <p className="idFind_id">{id}</p>
                </div>
            :""}
            <BtnBox
                boxType="fixed"
                addClass="col2"
            >
                <BtnItem
                    addClass="subColor"
                    contents={page === 0 ? "뒤로" : page === 1 ? "닫기" : id && id !== "" ? "비밀번호 찾기" : "닫기"}
                    func={() => {
                        window.idFindPopupClose();
                        if(page === 0){
                            reSet();
                            window.loginPopupOpen();
                        }else if(page === 2 && id && id !== ""){
                            reSet();
                            window.pwFindPopupOpen();
                        }
                    }}
                />
                <BtnItem
                    addClass=""
                    contents={page === 0 ? "인증번호 발송" : page === 1 ? "아이디 찾기" : id && id !== "" ? "로그인" : "회원가입"}
                    disabled={btnChk}
                    func={() => {nextFunc()}}
                />
            </BtnBox>
        </CustomPopup>
    );
};

const PwFindPopup = (data) => {
    const navigate = useNavigate();

    const [page,setPage] =  useState(0);

    const [id,setId] =  useState("");
    const [pw,setPw] =  useState("");
    const [pwCom,setPwCom] =  useState("");

    const [idErr,setIdErr] =  useState(null);
    const [pwErr,setPwErr] =  useState(null);
    const [pwComErr,setPwComErr] =  useState(null);

    const [cetified,setCetified] =  useState("");
    const [certifyErr,setCertifyErr] =  useState(null);
    const [timerCount,setTimerCount] =  useState("3:00");
    const [cetifiedChk,setCetifiedChk] =  useState(false);
    const [cetifiedComChk,setCetifiedComChk] =  useState(false);

    const [responseSeq,setResponseSeq] =  useState("");

    const [name,setName] =  useState("");
    const [birthday,setBirthday] =  useState("");
    const [phone,setPhone] =  useState("");
    const [phoneType,setPhoneType] =  useState("");
    const [gender,setGender] =  useState("m");

    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);

    const termsData = [
        {
            id:"service",
            title:"서비스 이용 약관"
        },
        {
            id:"privacy",
            title:"개인정보 수집 및 이용 동의"
        }
    ];

    const [checkItems, setCheckItems] = useState([]);
    const [checkItemTitles, setCheckItemTitles] = useState([]);

    function reSet(){
        setPage(0);

        setId("");
        setPw("");
        setPwCom("");

        setIdErr(null);
        setPwErr(null);
        setPwComErr(null);

        setCetified("");
        setCertifyErr(null);
        setTimerCount("3:00");
        setCetifiedChk(false);
        setCetifiedComChk(false);

        setResponseSeq("");

        setName("");
        setBirthday("");
        setPhone("");
        setPhoneType("");
        setGender("m");

        setBtnChk(true);
        setSubmitChk(true);

        setCheckItems([]);
        setCheckItemTitles([]);
    }

    const sval = useRef(null);
    function timerStart(){
        //타이머
        setTimerCount("3:00");
        setCertifyErr("");
        
        if (sval.current !== null) {
            clearInterval(sval.current);
            sval.current = null;
        }
        
        timerChk(2.99);

        function timerChk(duration) {
            let timerNumber = duration * 60;
            let m, s;
            sval.current = setInterval(function() {
                m = parseInt(timerNumber / 60 % 60, 10);
                s = parseInt(timerNumber % 60, 10);
                s = s < 10 ? "0" + s : s;

                setTimerCount(m + ":" + s);

                if (--timerNumber < 0) {
                    timerNumber = 0;
                    clearInterval(sval.current);
                    sval.current = null;
                    setCertifyErr("인증시간이 초과되었습니다.");
                    setCetifiedComChk(true);
                    setCetified("");

                    setBtnChk(false);
                }
            }, 1000);
        }
    }

    function cetifiedStert(){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("name", name);
            formData.append("birth", birthdaySet(birthday,gender));
            formData.append("phone", phone?.replace(/\-/g,""));
            formData.append("mobile_carrier", phoneType.val);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: null,
                url: `/certification`,
                success: (apiData) => {
                    setSubmitChk(true);

                    timerStart();
                    setCetified("");
                    setCetifiedChk(true);
                    window.loadingBox(false);

                    setBtnChk(true);

                    setResponseSeq(apiData?.data?.response_seq);

                    window.pwFindPopupTextCh({
                        title:"인증번호 입력",
                        subTitle:"SMS로 발송된 인증번호를 입력하세요."
                    });

                    if(page !== 2){
                        pageNextFunc();
                    }
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    function idChkFunc(){
        let idType = /(^(?=.*[a-z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]).{5,15}$)/;

        if(submitChk && idType.test(id)){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("login_id", id);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: null,
                url: `/id/check`,
                success: (apiData) => {
                    setSubmitChk(true);
                    window.loadingBox(false);

                    setIdErr(null);

                    window.pwFindPopupTextCh({
                        title:"본인인증 정보 입력",
                        subTitle:"비밀번호를 찾기 위해선 본인인증이 필요해요"
                    });

                    pageNextFunc();
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    window.errPopupOpen(apiData);
                    setIdErr("가입된 계정이 없습니다.");
                    window.loadingBox(false);
                }
            })
        }
    }

    // 체크박스 선택
    const handleSingleCheck = (checked, id, text) => {
        if (checked) {
            setCheckItemTitles(prev => [...prev, text]);
            setCheckItems(prev => [...prev, id]);
        } else {
            setCheckItemTitles(checkItemTitles.filter((el) => el !== text));
            setCheckItems(checkItems.filter((el) => el !== id));
        }
    };

    // 체크박스 전체 선택
    const handleAllCheck = (checked) => {
        if(checked) {
        const idArr = [],
            textArr = [];
            termsData?.forEach((el) => {idArr.push(el.id);textArr.push(el.term_title)});
            setCheckItemTitles(textArr);
            setCheckItems(idArr);
        }
        else {
            setCheckItemTitles([]);
            setCheckItems([]);
        }
    }

    function pageNextFunc(){
        setBtnChk(true);
        setIdErr(null);
        setPwErr(null);
        setPwComErr(null);
                    
        setPage(page + 1);
    }

    function pageNext(){
        if(page == 0){
            idChkFunc();
        }else if(page == 1){
            cetifiedStert();
        }else if(page == 2){
            if(submitChk){
                if(cetifiedChk){
                    setSubmitChk(false);
                    window.loadingBox(true);

                    let formData = new FormData();

                    formData.append("name", name);
                    formData.append("birth", birthdaySet(birthday,gender));
                    formData.append("phone", phone?.replace(/\-/g,""));
                    formData.append("mobile_carrier", phoneType.val);

                    formData.append("response_seq", responseSeq);
                    formData.append("certification_code", cetified);
                    formData.append("find_password", 1);

                    fatchSet.FatchApi({
                        type:"POST",
                        formDataItem: formData,
                        loginType: null,
                        url: `/certification/check`,
                        success: (apiData) => {
                            setSubmitChk(true);

                            setBtnChk(false);
                            setCetifiedComChk(true);

                            setTimerCount("3:00");
                            setCertifyErr("");

                            clearInterval(sval.current);
                            sval.current = null;

                            window.loadingBox(false);
                            
                            window.pwFindPopupTextCh({
                                title:"새로운 비밀번호 설정",
                                subTitle:"로그인 시 사용할 새로운 비밀번호를 입력해주세요."
                            });

                            sessionStorage.setItem("token",apiData?.data?.token?.access_token)
        
                            pageNextFunc();
                        },
                        err: (apiData) => {
                            setSubmitChk(true);
                            if(apiData.alert){
                                setCertifyErr(apiData.alert);
                            }
                            window.loadingBox(false);
                        }
                    })
                }else{
                    cetifiedStert();setCetifiedComChk(false);setCetified("")
                }
            }
        }else if(page === 3){
            if(submitChk){
                setSubmitChk(false);
                window.loadingBox(true);

                let formData = new FormData();

                formData.append("password", pw);

                fatchSet.FatchApi({
                    type:"POST",
                    formDataItem: formData,
                    loginType: "sessionLogin",
                    url: `/password/modify`,
                    success: (apiData) => {
                        setSubmitChk(true);

                        setBtnChk(false);

                        window.loadingBox(false);

                        sessionStorage.removeItem("token")

                        window.errPopupOpen({
                            alert:"비밀번호 변경 완료",
                            data:"비밀번호 변경이 완료되었습니다.<br/>지금 바로 서비스를 이용해보세요!",
                            closeType:false,
                            func:()=>{
                                window.pwFindPopupClose();
                                reSet();
                                window.loginPopupOpen();
                            }
                        });
                    },
                    err: (apiData) => {
                        setSubmitChk(true);
                        if(apiData?.data || apiData?.alert){
                            window.errPopupOpen(apiData);
                        }
                        window.loadingBox(false);
                    }
                })
            }
        }
    }

    useEffect(() => {
        let idType = /(^(?=.*[a-z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]).{5,15}$)/;

        if(!idType.test(id) && id !== ""){
            setIdErr("5자 ~ 15자 영문 소문자, 숫자로 입력하세요.")
        }else{
            setIdErr(null)
        }

        if(page == 0){
            if(
                idType.test(id) && id !== ""
            ){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [id]);

    useEffect(() => {
        let ragChk = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/g;
        let phoneChk = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
        let chkSet = [...checkItems];
        if(page == 1){
            if(name.length > 0 
            && ragChk.test(birthday)
            && gender
            && phoneChk.test(phone?.replace(/\-/g,""))
            && phoneType.val
            && chkSet.length == (termsData ? termsData?.length : 0)){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [name,birthday,gender,phone,phoneType,checkItems]);

    useEffect(() => {
        if(page == 2){
            if(cetified.length == 6){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [cetified,cetifiedChk]);

    useEffect(() => {
        let pwType = /^(?=.*[a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]).{8,16}$/;

        if(pw !== pwCom && pw !== "" && pwCom !== ""){
            setPwComErr("비밀번호가 일치하지 않습니다.")
        }else{
            setPwComErr(null)
        }

        if(!pwType.test(pw) && pw !== ""){
            setPwErr("8자 ~ 16자 영문, 숫자, 특수문자로 입력하세요.")
        }else{
            setPwErr(null)
        }

        if(page == 3){
            if(
                pwType.test(pw) && pw !== ""
                && pw == pwCom && pwType.test(pw)
            ){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [pw,pwCom]);

    useEffect(() => {
        if(data.popupData === null){
            reSet();
        }
    }, [data.popupData]);
    

    return (
        <CustomPopup data={data.popupData}>
            {page === 0 ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="아이디"
                    placeholder="5자 ~ 15자의 영문 소문자, 숫자 입력"
                    value={id}
                    max={15}
                    regexp={/[^a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi}
                    func={(value)=>{setId(value)}}
                    errMsg={idErr}
                    idInputMsgChk={true}
                />
                </>
            : page === 1 ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="휴대폰 번호"
                    placeholder="‘-’ 없이 입력"
                    value={phone}
                    max={13}
                    phoneSetting={true}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setPhone(value);setCetifiedChk(false);setCetifiedComChk(false);setCetified("")}}
                />
                <CustomSelect
                    addClass="notName absoluteSel"
                    inputName="통신사"
                    placeholder="선택"
                    value={phoneType?.val}
                    func={(name,val) => {
                        let dataSet = {
                            val:val,
                            text:name
                        }
                        setPhoneType(dataSet);
                    }}
                    disabled={false}
                    valKey="id"
                    nameKey="name"
                    options={[
                        {id:1,name:"SKT"},
                        {id:2,name:"KT"},
                        {id:3,name:"LGU+"},
                        {id:5,name:"알뜰폰(SKT)"},
                        {id:6,name:"알뜰폰(KT)"},
                        {id:7,name:"알뜰폰(LGU+)"}
                    ]}
                />
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="이름"
                    placeholder="이름"
                    value={name}
                    max={18}
                    regexp={null}
                    func={(value)=>{setName(value)}}
                />
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="생년월일"
                    placeholder="YYYYMMDD"
                    value={birthday}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    max={8}
                    func={(value)=>{setBirthday(value)}}

                    inBtnArr={[
                        {
                            val: "m", 
                            text: "남", 
                            func: (val)=>{setGender(val)}
                        },
                        {
                            val: "f", 
                            text: "여", 
                            func: (val)=>{setGender(val)}
                        }
                    ]}
                    inBtnValue={gender}
                />
                <InputChkSection>
                    <ChkBox
                        addClass="allChkItem"
                        func={(e) => handleAllCheck(e.target.checked)}
                        checkedType={checkItems?.length === (termsData ? termsData?.length : 0) ? true : false}
                        label="전체 약관에 동의합니다."
                    />
                    {termsData?.map((item, i) => (
                        <ChkBox
                            key={i}
                            addClass=""
                            func={(e) => handleSingleCheck(e.target.checked,item.id,item.title)}
                            checkedType={checkItems.includes(item.id) ? true : false}
                            label={`<span>[필수]</span> ${item.title}`}
                            chkFunc={(e) => window.termsPopupOpen(item.id,item.title)}
                        />
                    ))}
                </InputChkSection>
                </>
            : page === 2 && cetifiedChk ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass="cetifiedInput"
                    inputName="인증번호"
                    placeholder="인증번호 6자리"
                    value={cetified}
                    max={6}
                    readOnly={cetifiedComChk}
                    cetified={timerCount}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setCetified(value)}}
                    errMsg={certifyErr}
                    subBtn="인증번호 재발송"
                    inputSubFunc={()=>{cetifiedStert();setCetifiedComChk(false);setCetified("")}}
                />
                </>
            : page === 3 ? 
                <>
                <InputItemBox
                    inputType="password"
                    addClass=""
                    inputName="새 비밀번호"
                    placeholder="8~16자 영문, 숫자, 특수문자 (대소문자 구분)"
                    pwChType={false}
                    value={pw}
                    max={16}
                    regexp={null}
                    errMsg={pwErr}
                    func={(value)=>{setPw(value)}}
                />
                <InputItemBox
                    inputType="password"
                    addClass=""
                    inputName="새 비밀번호 확인"
                    placeholder="8~16자 영문, 숫자, 특수문자 (대소문자 구분)"
                    pwChType={false}
                    value={pwCom}
                    max={16}
                    regexp={null}
                    errMsg={pwComErr}
                    func={(value)=>{setPwCom(value)}}
                /> 
                </>
            :""}
            <BtnBox
                boxType="fixed"
                addClass="col2"
            >
                <BtnItem
                    addClass="subColor"
                    contents={page === 0 ? "뒤로" : "닫기"}
                    func={() => {
                        window.pwFindPopupClose();
                        if(page === 0){
                            reSet();
                            window.loginPopupOpen();
                        }
                    }}
                />
                <BtnItem
                    addClass=""
                    contents={page === 0 ? "다음" : page === 1 ? "인증번호 발송" : page === 2 ? "새로운 비밀번호 설정" : "비밀번호 설정 완료"}
                    disabled={btnChk}
                    func={() => {pageNext()}}
                />
            </BtnBox>
        </CustomPopup>
    );
};

const NaviPopup = (data) => {

    function startKakaoNavigation(){
        const setData = data.popupData?.kakaoUrl;

        if(window.Kakao && setData){
            if(!window.Kakao.isInitialized()){
                window.Kakao.init(process.env.REACT_APP_KAKAO_CLIENT_ID);
            }

            window.Kakao.Navi.start({
                name: setData?.name,
                x: Number(setData?.x),
                y: Number(setData?.y),
                coordType:"wgs84"
            });
        }
    }

    useEffect(() => {
        if(window.Kakao){
            if(!window.Kakao.isInitialized()){
                window.Kakao.init(process.env.REACT_APP_KAKAO_CLIENT_ID);
            }
        }
    }, []);

    return (
        <CustomPopup data={data.popupData} toastType={true} basicPB={true}>
            <div className="snsBtnBox">
                <SnsBtn
                    btnType="link"
                    img="naver_n"
                    btnLink={`${window.location.protocol}//${window.location.host}/navi/naver`}
                    func={() => {}}
                />
                <SnsBtn
                    img="kakao_n"
                    func={() => {startKakaoNavigation()}}
                />
                <SnsBtn
                    btnType="link"
                    img="tmap"
                    btnLink={`${window.location.protocol}//${window.location.host}/navi/tmap`}
                    func={() => {}}
                />
            </div>
        </CustomPopup>
    );
};

const RentPopupContents = (data) => {
    const copyInputRef = useRef(null);

    const [addrName,setAddrName] =  useState("");
    const [addrPosition,setAddrPosition] =  useState({});

    const [kakaoUrl,setKaKaoUrl] =  useState("/");

    const rentAddr = process.env.REACT_APP_RENT_ADDR;
    
    function sharingFunc(){
        copyInputRef?.current?.select();
        document.execCommand('copy');
        copyInputRef?.current?.blur();
        window.errMsg("클립보드에 복사되었습니다.");
    }

    //주소로 좌표 추출
    function positionData(addr){
        setTimeout(() => {
            if(addr){
                let geocoder = new window.kakao.maps.services.Geocoder();
                let agent = navigator.userAgent;

                geocoder.addressSearch(addr, function(result, status) {
                    if (status === window.kakao.maps.services.Status.OK) {
                        let positionData = {
                            lat:result[0].y,
                            lng:result[0].x
                        }

                        setAddrName(result[0]?.road_address?.building_name||addr);
                        setAddrPosition(positionData);
                        data.func(positionData);

                        setKaKaoUrl({
                            name : result[0]?.road_address?.building_name||addr,
                            x : result[0].x,
                            y : result[0].y
                        });
                    } 
                });
            }
        }, 200);
    }

    useEffect(() => {
        if(data.popup){
            setAddrPosition({});
            positionData(rentAddr);
        }
    }, [data.popup]);
    
    useEffect(() => {
        if(rentAddr){
            setAddrPosition({});
            positionData(rentAddr);
        }
    }, []);

    return (
        <div className="addrArea">
            <div className="addrBox">
                {addrPosition?.lat && addrPosition?.lng ? 
                    <Map
                        center={{ lat: Number(addrPosition?.lat), lng: Number(addrPosition?.lng) }}
                        style={{ width: "100%", height: "260px" }}
                    >
                        <MapMarker position={{ lat: Number(addrPosition?.lat), lng: Number(addrPosition?.lng) }}/>
                    </Map>
                :""}
            </div>
            <div className="mapPopupInfo">
                <h1 className="mapPopupInfo_addrName">{addrName}</h1>
                <div className="mapPopupInfo_addrBox">
                    <p className="mapPopupInfo_addr">{rentAddr}</p>
                    <button type="button" onClick={()=>{sharingFunc()}} className="mapPopupInfo_addrCopy">주소복사</button>
                    <textarea autoComplete="off" ref={copyInputRef} defaultValue={rentAddr} className="copyInput"/>
                </div>
            </div>
            <div className="mapPopupInfo">
                <h1 className="mapPopupInfo_addrName">AMANO 렌터카허브 제휴 렌터카사 대여/반납지 확인</h1>
                <div className="mapPopupInfo_addrBox">

                    <BtnItem
                        addClass="flex gradient linkButton"
                        contents="바로가기 &nbsp;> "
                        func={() => {window.location.href = "/notice/detail/7"}}
                    />
                    <button type="button" onClick={()=>{window.location.href = "/notice/detail/7"}} className="mapPopupInfo_addrCopy"></button>
                </div>
            </div>
            {addrPosition?.lat && addrPosition?.lng && isMobile() ? 
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass="subColor"
                        contents="내비게이션 안내"
                        func={() => {
                            window.naviPopupOpen({
                                kakaoUrl:kakaoUrl
                            })
                        }}
                    />
                </BtnBox>
            :""}
        </div>
    );
};

const PwEditPopup = (data) => {
    const navigate = useNavigate();

    const [pw,setPw] =  useState("");
    const [pwCom,setPwCom] =  useState("");

    const [pwErr,setPwErr] =  useState(null);
    const [pwComErr,setPwComErr] =  useState(null);

    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);

    function reSet(){
        setPw("");
        setPwCom("");

        setPwErr(null);
        setPwComErr(null);

        setBtnChk(true);
        setSubmitChk(true);
    }

    function editPwFunc(){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("password", pw);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/mypage/change/password`,
                success: (apiData) => {
                    setSubmitChk(true);
                    window.loadingBox(false);

                    setBtnChk(true);

                    window.errPopupOpen({
                        alert:"비밀번호 변경 완료",
                        data:"비밀번호 변경이 완료되었습니다.<br/>지금 바로 서비스를 이용해보세요!",
                        closeType:false,
                        func:()=>{
                            data.close();
                            reSet();
                        }
                    });
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    useEffect(() => {
        let pwType = /^(?=.*[a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]).{8,16}$/;

        if(pw !== pwCom && pw !== "" && pwCom !== ""){
            setPwComErr("비밀번호가 일치하지 않습니다.")
        }else{
            setPwComErr(null)
        }

        if(!pwType.test(pw) && pw !== ""){
            setPwErr("8자 ~ 16자 영문, 숫자, 특수문자로 입력하세요.")
        }else{
            setPwErr(null)
        }

        if(pwType.test(pw) && pw !== "" && pw == pwCom && pwType.test(pw)){
            setBtnChk(false)
        }else{
            setBtnChk(true)
        }
    }, [pw,pwCom]);

    useEffect(() => {
        if(data.popupData === null){
            reSet();
        }
    }, [data.popupData]);
    
    return (
        <CustomPopup data={data.popupData}>
            <InputItemBox
                inputType="password"
                addClass=""
                inputName="새 비밀번호"
                placeholder="8~16자 영문, 숫자, 특수문자 (대소문자 구분)"
                pwChType={false}
                value={pw}
                max={16}
                regexp={null}
                errMsg={pwErr}
                func={(value)=>{setPw(value)}}
            />
            <InputItemBox
                inputType="password"
                addClass=""
                inputName="새 비밀번호 확인"
                placeholder="8~16자 영문, 숫자, 특수문자 (대소문자 구분)"
                pwChType={false}
                value={pwCom}
                max={16}
                regexp={null}
                errMsg={pwComErr}
                func={(value)=>{setPwCom(value)}}
            /> 
            <BtnBox
                boxType="fixed"
                addClass="col2"
            >
                <BtnItem
                    addClass="subColor"
                    contents={"취소"}
                    func={() => {
                        reSet();
                        data.close();
                    }}
                />
                <BtnItem
                    addClass=""
                    contents={"비밀번호 설정 완료"}
                    disabled={btnChk}
                    func={() => {editPwFunc()}}
                />
            </BtnBox>
        </CustomPopup>
    );
};

const ProfileEditPopup = (data) => {
    const navigate = useNavigate();

    const [page,setPage] =  useState(0);

    const [cetified,setCetified] =  useState("");
    const [certifyErr,setCertifyErr] =  useState(null);
    const [timerCount,setTimerCount] =  useState("3:00");
    const [cetifiedChk,setCetifiedChk] =  useState(false);
    const [cetifiedComChk,setCetifiedComChk] =  useState(false);

    const [responseSeq,setResponseSeq] =  useState("");

    const [name,setName] =  useState("");
    const [birthday,setBirthday] =  useState("");
    const [phone,setPhone] =  useState("");
    const [phoneType,setPhoneType] =  useState("");
    const [gender,setGender] =  useState("m");

    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);

    function reSet(){
        setPage(0);

        setCetified("");
        setCertifyErr(null);
        setTimerCount("3:00");
        setCetifiedChk(false);
        setCetifiedComChk(false);

        setResponseSeq("");

        setName("");
        setBirthday("");
        setPhone("");
        setPhoneType("");
        setGender("m");

        setBtnChk(true);
        setSubmitChk(true);
    }

    const sval = useRef(null);
    function timerStart(){
        //타이머
        setTimerCount("3:00");
        setCertifyErr("");
        
        if (sval.current !== null) {
            clearInterval(sval.current);
            sval.current = null;
        }
        
        timerChk(2.99);

        function timerChk(duration) {
            let timerNumber = duration * 60;
            let m, s;
            sval.current = setInterval(function() {
                m = parseInt(timerNumber / 60 % 60, 10);
                s = parseInt(timerNumber % 60, 10);
                s = s < 10 ? "0" + s : s;

                setTimerCount(m + ":" + s);

                if (--timerNumber < 0) {
                    timerNumber = 0;
                    clearInterval(sval.current);
                    sval.current = null;
                    setCertifyErr("인증시간이 초과되었습니다.");
                    setCetifiedComChk(true);
                    setCetified("");

                    setBtnChk(false);
                }
            }, 1000);
        }
    }

    function cetifiedStert(){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("name", name);
            formData.append("birth", birthdaySet(birthday,gender));
            formData.append("phone", phone?.replace(/\-/g,""));
            formData.append("mobile_carrier", phoneType.val);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/certification`,
                success: (apiData) => {
                    setSubmitChk(true);

                    timerStart();
                    setCetified("");
                    setCetifiedChk(true);
                    window.loadingBox(false);

                    setBtnChk(true);

                    setResponseSeq(apiData?.data?.response_seq);

                    data.popupData?.textCh({
                        addClass:"subTitle_line_1",
                        title:"인증번호 입력",
                        subTitle:"SMS로 발송된 인증번호를 입력하세요."
                    });

                    if(page !== 1){
                        pageNextFunc();
                    }
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    function pageNextFunc(){
        setBtnChk(true);
                    
        setPage(page + 1);
    }

    function pageNext(){
        if(page == 0){
            cetifiedStert();
        }else if(page == 1){
            if(submitChk){
                if(cetifiedChk){
                    setSubmitChk(false);
                    window.loadingBox(true);

                    let formData = new FormData();

                    formData.append("name", name);
                    formData.append("birth", birthdaySet(birthday,gender));
                    formData.append("phone", phone?.replace(/\-/g,""));
                    formData.append("mobile_carrier", phoneType.val);

                    formData.append("response_seq", responseSeq);
                    formData.append("certification_code", cetified);

                    fatchSet.FatchApi({
                        type:"POST",
                        formDataItem: formData,
                        loginType: "login",
                        url: `/certification/check`,
                        success: (apiData) => {
                            setSubmitChk(true);

                            setBtnChk(false);
                            setCetifiedComChk(true);

                            setTimerCount("3:00");
                            setCertifyErr("");

                            clearInterval(sval.current);
                            sval.current = null;

                            window.loadingBox(false);
                            
                            window.errPopupOpen({
                                alert:"회원정보 변경 완료",
                                data:"회원 정보가 정상적으로 변경되었습니다.<br/>휴대폰 번호 로그인 시 변경된 정보로 로그인 해주세요.",
                                closeType:false,
                                func:()=>{
                                    data.close();
                                    reSet();
                                    
                                    window.location.reload(true);
                                }
                            });
                        },
                        err: (apiData) => {
                            setSubmitChk(true);
                            if(apiData.alert){
                                setCertifyErr(apiData.alert);
                            }
                            window.loadingBox(false);
                        }
                    })
                }else{
                    cetifiedStert();setCetifiedComChk(false);setCetified("")
                }
            }
        }
    }

    useEffect(() => {
        let ragChk = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/g;
        let phoneChk = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

        if(page == 0){
            if(name.length > 0 
            && ragChk.test(birthday)
            && gender
            && phoneChk.test(phone?.replace(/\-/g,""))
            && phoneType.val){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [name,birthday,gender,phone,phoneType]);

    useEffect(() => {
        if(page == 1){
            if(cetified.length == 6){
                setBtnChk(false)
            }else{
                setBtnChk(true)
            }
        }
    }, [cetified,cetifiedChk]);

    useEffect(() => {
        if(data.popupData === null){
            reSet();
        }
    }, [data.popupData]);

    return (
        <CustomPopup data={data.popupData}>
            {page === 0 ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="휴대폰 번호"
                    placeholder="‘-’ 없이 입력"
                    value={phone}
                    max={13}
                    phoneSetting={true}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setPhone(value);setCetifiedChk(false);setCetifiedComChk(false);setCetified("")}}
                />
                <CustomSelect
                    addClass="notName absoluteSel"
                    inputName="통신사"
                    placeholder="선택"
                    value={phoneType?.val}
                    func={(name,val) => {
                        let dataSet = {
                            val:val,
                            text:name
                        }
                        setPhoneType(dataSet);
                    }}
                    disabled={false}
                    valKey="id"
                    nameKey="name"
                    options={[
                        {id:1,name:"SKT"},
                        {id:2,name:"KT"},
                        {id:3,name:"LGU+"},
                        {id:5,name:"알뜰폰(SKT)"},
                        {id:6,name:"알뜰폰(KT)"},
                        {id:7,name:"알뜰폰(LGU+)"}
                    ]}
                />
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="이름"
                    placeholder="이름"
                    value={name}
                    max={18}
                    regexp={null}
                    func={(value)=>{setName(value)}}
                />
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="생년월일"
                    placeholder="YYYYMMDD"
                    value={birthday}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    max={8}
                    func={(value)=>{setBirthday(value)}}

                    inBtnArr={[
                        {
                            val: "m", 
                            text: "남", 
                            func: (val)=>{setGender(val)}
                        },
                        {
                            val: "f", 
                            text: "여", 
                            func: (val)=>{setGender(val)}
                        }
                    ]}
                    inBtnValue={gender}
                />
                </>
            : page === 1 && cetifiedChk ? 
                <>
                <InputItemBox
                    inputType={null}
                    addClass="cetifiedInput"
                    inputName="인증번호"
                    placeholder="인증번호 6자리"
                    value={cetified}
                    max={6}
                    readOnly={cetifiedComChk}
                    cetified={timerCount}
                    regexp={"number"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    func={(value)=>{setCetified(value)}}
                    errMsg={certifyErr}
                    subBtn="인증번호 재발송"
                    inputSubFunc={()=>{cetifiedStert();setCetifiedComChk(false);setCetified("")}}
                />
                </>
            :""}
            <BtnBox
                boxType="fixed"
                addClass="col2"
            >
                <BtnItem
                    addClass="subColor"
                    contents={"취소"}
                    func={() => {
                        reSet();
                        data.close();
                    }}
                />
                <BtnItem
                    addClass=""
                    contents={page === 0 ? "인증번호 발송" : "인증 완료"}
                    disabled={btnChk}
                    func={() => {pageNext()}}
                />
            </BtnBox>
        </CustomPopup>
    );
};


export {TermsPopup,DateSelectPopup,InsurancePopup,WelComePopup,SnsBtn,NomMemberPopup,LoginPopup,JoinPopup,IdFindPopup,PwFindPopup,NaviPopup,RentPopupContents,PwEditPopup,ProfileEditPopup};